export function authHeader () {
    // return authorization header with jwt token
    let authToken = localStorage.getItem('authToken');

    if( !authToken ) return {};

    return { 'Authorization': `Bearer ${authToken}` };
}

let AMBROSIAS = {
    dev : 'http://localhost:9898', // -- For localhost
    dev_alt : `http://${location.hostname}:9898`, // -- For local LAN IP
    test : 'https://ambrosia-sandbox.gofarma.com',
    production : 'https://ambrosia.gofarma.com'
};


/**
 * @return {string}
 */
let GetEnv = function( host ){
    if( host.indexOf( 'localhost' ) > -1 ) return 'dev';
    if( host.indexOf( '127.0.0.1' ) > -1 ) return 'dev';
    if( host.indexOf( 'lvh.me' ) > -1 ) return 'dev';
    if( host.indexOf( '192.168' ) > -1 ) return 'dev_alt';
    if( host.indexOf( '.gofarma.com' ) > -1 ) return 'test';
    return 'production';
};

export const AMBROSIA_URL = AMBROSIAS[ GetEnv( location.host ) ];
export const ATHENA_URL = 'https://athena.gofarma.com';
window.AMBRO = AMBROSIA_URL;
